import { strategyTickerDay } from '@/features/backtest/utils/run-ticker-day'

const RUN_DAY_PARAMS = ['symbol', 'targetDate'] as const

interface RedirectNode {
  id: string
  type?: string
  data?: unknown
}
interface RedirectEdge {
  source: string
  target: string
  data?: unknown
}

export interface RunDayRedirect {
  /** The Stock Selection that takes the run's ticker and day; null when nothing moves. */
  universeId: string | null
  /** What the Stock Selection takes. */
  moved: Record<string, unknown>
  /** What stays on the Price Data. */
  kept: Record<string, unknown>
}

/**
 * Older AI habits set the run's `symbol` / `targetDate` on a Price Data. With a
 * Stock Selection connected those two belong to it (spec 2026-10-28), so they
 * are split off to it; with none connected they stay on the Price Data, which
 * is what the run reads then. Every other param stays where it was addressed.
 */
export function redirectRunDayParams(
  nodes: readonly RedirectNode[],
  edges: readonly RedirectEdge[],
  nodeId: string,
  params: Record<string, unknown>,
): RunDayRedirect {
  const stay: RunDayRedirect = { universeId: null, moved: {}, kept: params }
  const target = nodes.find((n) => n.id === nodeId)
  if (target?.type !== 'priceData') return stay
  if (!RUN_DAY_PARAMS.some((name) => name in params)) return stay
  const day = strategyTickerDay(nodes, edges)
  if (day.from !== 'stock-selection' || !day.nodeId) return stay
  const moved: Record<string, unknown> = {}
  const kept: Record<string, unknown> = {}
  for (const [name, value] of Object.entries(params)) {
    if ((RUN_DAY_PARAMS as readonly string[]).includes(name)) moved[name] = value
    else kept[name] = value
  }
  return { universeId: day.nodeId, moved, kept }
}
